import styled from 'styled-components'
import tw, { classnames, TBorderColor, overflow, padding, borderRadius, backgroundColor, borderWidth, borderColor, flexWrap, position } from 'tailwindcss-classnames'

const base = classnames(backgroundColor('dark:bg-gray-800' as any), borderColor('dark:border-gray-700' as any), 'bg-title' as any, overflow('overflow-hidden'), padding('px-0', 'pb-0'), borderRadius('rounded-md'), backgroundColor('bg-white'), borderWidth('border'), borderColor('border-gray-200'), flexWrap('flex-wrap'), position('relative'));
export const BoxContainer = (rounded: string) => styled.div.attrs({
    className: classnames(base, `rounded-$, ` as any, borderRadius({ rounded: rounded } as any))
})``;
